<template>
  <md-card
    class="md-card-unspaced public-interactions-card rfider-shadow"
    style=""
  >
    <div
      class="md-layout public-interactions-view"
      @click="isCompactCollapsed = !isCompactCollapsed"
    >
      <div class="md-layout-item md-size-15 public-interactions-view-icon">
        <div
          class="public-interactions-avatar"
          :style="{
            'background-image': !item.image
              ? 'none'
              : `url(${mixinGetFilePath(item.image, 'O')})`,
            'background-color': !item.image ? '#0B7EE4' : 'none',
          }"
        >
          <div
            class="public-interactions-avatar-icon"
            :style="{
              'background-image': !iconPath ? 'none' : `url(${iconPath})`,
            }"
          ></div>
        </div>
      </div>
      <div class="md-layout md-layout-item md-size-85 public-interactions-info">
        <div class="title md-layout-item md-size-100">{{ item.name }}</div>
        <!-- <div class="md-layout md-layout-item md-size-100">
          <div class="md-layout-item md-size-70">
            {{ enrichedData.location }}
          </div>
          <div
            class="md-layout-item md-size-30"
            style="text-align: right; padding-right: 20px;"
          >
            {{
              item.interactions.length
                ? displayTimeZone(
                    item.interactions[0].createdAt,
                    'DD MMM, YYYY',
                  )
                : ''
            }}
          </div>
        </div> -->
        <div class="md-layout md-layout-item md-size-100">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-98 public-interactions-transportation"
            >
              <span
                class="md-layout-item public-interactions-transportation-icon-left"
              >
                <span v-if="!previousTransportationMethod">&nbsp;</span>
                <img
                  v-if="previousTransportationMethod === 'truck'"
                  src="/img/icons/Truck_White.png"
                />
                <img
                  v-else-if="previousTransportationMethod === 'rail'"
                  src="/img/icons/Rail_White.png"
                />
                <img
                  v-else-if="previousTransportationMethod === 'air'"
                  src="/img/icons/Air_White.png"
                />
                <img
                  v-else-if="previousTransportationMethod === 'maritime'"
                  src="/img/icons/Maritime_White.png"
                />
                <img
                  v-else-if="previousTransportationMethod === 'multimodal'"
                  src="/img/icons/Multimodel_White.png"
                />
                <img
                  v-else-if="previousTransportationMethod === 'bicycle'"
                  src="/img/icons/Bicycle_White.png"
                />
                <img
                  v-else-if="
                    previousTransportationMethod === 'courier_or_postal'
                  "
                  src="/img/icons/Courier_White.png"
                />
              </span>

              <span
                class="md-layout-item public-interactions-transportation-icon-right"
                :style="{ right: isFirst ? '65%' : '' }"
              >
                <span v-if="!item.transportationMethod">&nbsp;</span>
                <img
                  v-if="isFirst || isLast"
                  class="arrow"
                  src="/img/icons/transportation_arrow.png"
                  :style="{ 'margin-right': isFirst ? '5px' : '20px' }"
                />
                <img
                  v-if="isLast"
                  src="/img/icons/vc-default-customer-icon.png"
                  class="customer"
                />
                <img
                  v-if="item.transportationMethod === 'truck'"
                  src="/img/icons/Truck_White.png"
                />
                <img
                  v-else-if="item.transportationMethod === 'rail'"
                  src="/img/icons/Rail_White.png"
                />
                <img
                  v-else-if="item.transportationMethod === 'air'"
                  src="/img/icons/Air_White.png"
                />
                <img
                  v-else-if="item.transportationMethod === 'maritime'"
                  src="/img/icons/Maritime_White.png"
                />
                <img
                  v-else-if="item.transportationMethod === 'multimodal'"
                  src="/img/icons/Multimodel_White.png"
                />
                <img
                  v-else-if="item.transportationMethod === 'bicycle'"
                  src="/img/icons/Bicycle_White.png"
                />
                <img
                  v-else-if="item.transportationMethod === 'courier_or_postal'"
                  src="/img/icons/Courier_White.png"
                />
              </span>
              <div
                :class="{
                  'public-interactions-transportation-arrow': !isLast,
                  'public-interactions-transportation-no-arrow': isLast,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-size-100">
        <div>
          {{ item.description }}
        </div>
      </div>
    </div>
    <div
      v-if="
        item.interactions.length ||
        beforeEventsMisc.length ||
        afterEventsMisc.length
      "
    >
      <div v-if="!isCompactCollapsed">
        <div class="md-layout public-interactions-view">
          <div class="md-layout-item md-size-100">
            <div
              v-for="(component, index) in beforeEventsMisc"
              :key="`before-${index}`"
              class="public-interactions-component"
            >
              <public-support :item="component"></public-support>
            </div>

            <public-interactions-event-view-timeline
              :items="item.interactions"
            ></public-interactions-event-view-timeline>

            <div
              v-for="(component, index) in afterEventsMisc"
              :key="`after-${index}`"
              class="public-interactions-component"
            >
              <public-support :item="component"></public-support>
            </div>
          </div>
        </div>
      </div>
      <div class="text-align--center">
        <md-button
          @click="isCompactCollapsed = !isCompactCollapsed"
          class="md-simple public-interactions-btn-element"
          >{{ isCompactCollapsed ? 'Explore' : 'Hide' }}</md-button
        >
      </div>
    </div>
    <div v-else style="margin-bottom: 10px"></div>
  </md-card>
</template>

<script>
import PublicSupport from '@/components/public/publicSupport.vue';
import PublicInteractionsEventViewTimeline from './publicInteractionsEventViewTimeline';
import timeZone from '@/mixins/timeZone';

export default {
  mixins: [timeZone],
  components: {
    PublicSupport,
    PublicInteractionsEventViewTimeline,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    previousTransportationMethod: {
      type: String,
      required: false,
    },
    isLast: {
      type: Boolean,
      required: false,
    },
    isFirst: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isCompactCollapsed: true,
    };
  },
  computed: {
    enrichedData() {
      let data = {};

      if (this.item.interactions.length && this.item.interactions[0].metadata) {
        const { temp, rh, aqi } =
          this.item.interactions[0].metadata.location.weather || {};
        const { components } =
          this.item.interactions[0].metadata.location.details || {};

        const location = !components
          ? []
          : components
              .filter((element) => {
                return element.types.includes('political');
              })
              .slice(-2);

        if (location.length > 0) {
          let city = location[0] ? location[0].long_name : null;
          let country = location[1] ? location[1].long_name : null;
          if (city) {
            data.location = city;
            if (country) {
              data.location = `${city}, ${country}`;
            }
          }
        } else {
          data.location = 'Unknown Location';
        }

        if (temp && rh && aqi) {
          data.weather =
            `${temp}°C` + ' | ' + `RH ${rh}%` + ' | ' + `AQI ${aqi}`;
        } else {
          data.weather = 'Weather Unavailable';
        }
      }

      return data;
    },
    beforeEventsMisc() {
      let comps = [];

      if (this.item.comps && this.item.comps.length) {
        comps = this.item.comps.filter(
          (c) =>
            c.subType === null &&
            (!c.publicPagePosition ||
              (c.publicPagePosition &&
                c.publicPagePosition.component === 'events' &&
                c.publicPagePosition.position === 'before')),
        );
      }

      return comps;
    },
    afterEventsMisc() {
      let comps = [];

      if (this.item.comps && this.item.comps.length) {
        comps = this.item.comps.filter(
          (c) =>
            c.subType === null &&
            c.publicPagePosition &&
            c.publicPagePosition.component === 'events' &&
            c.publicPagePosition.position === 'after',
        );
      }

      return comps;
    },
    iconPath() {
      let iconPath = null;

      if (this.item && this.item.iconPath) {
        iconPath = this.mixinGetFilePath(this.item.iconPath, 'O');
      } else if (this.item && this.item.icon) {
        iconPath = this.mixinGetFilePath(this.item.icon, 'O');
      }

      return iconPath;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions.scss';
</style>
